import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const entryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-workflow-readonly-modal" */ './ui/modal/index'),
	),
	getPreloadProps: () => ({}),
});
